import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { ArrowRight as ArrowRightIcon } from 'react-feather';
import { Button, Typography } from 'ui-kit';

import { useGuestCartDetail } from 'api/guest_sdk';
import { reverse } from 'utils/urls';
import { classNames } from 'utils';

import { URLS } from 'components/Routes/urls';
import RecommendedItems from './RecommendedItems';
import CartItem from 'components/Store/NewCheckout/CartItem';

import './Cart.scss';

interface IProps {
  className?: string;
  isOpen: boolean;
  storeId: number;
  onEdit: () => void;
  mutateStoreList: () => void;
  storeCurrency: string;
}

const Cart = ({ className, isOpen, storeId, onEdit, mutateStoreList, storeCurrency }: IProps) => {
  const { data, mutate: mutateGuestCart } = useGuestCartDetail({
    storeId,
  });
  const history = useHistory();

  const orderId = useMemo(() => data?.id, [data]);
  const totalQuantity = useMemo(() => data?.order_product_quantity || 0, [data]);
  const currency = useMemo(() => data?.currency, [data]);
  const orderProducts = useMemo(() => data?.order_products || [], [data]);

  const handleUpdateQuantity = useCallback(() => {
    mutateStoreList();
    mutateGuestCart();
  }, []);

  return (
    <div className={classNames(className, 'Cart', isOpen && 'Cart___open')}>
      <div className="Cart_head">
        <Typography className="Cart_head-title" variant="h6">
          My Cart
        </Typography>
        <Typography variant="caption" color="textGray">
          {totalQuantity > 1 ? `${totalQuantity} items` : `${totalQuantity} item`}
        </Typography>
      </div>
      {orderProducts.length > 0 && (
        <Button
          variant="contained"
          fullWidth
          onClick={() =>
            history.push(
              reverse({
                url: URLS.CART_DETAILS,
                params: { storeId },
              }),
            )
          }
          endIcon={<ArrowRightIcon />}
        >
          Checkout now
        </Button>
      )}
      <div className="Cart_body">
        {orderProducts.length > 0 ? (
          orderProducts.map((orderProduct) => (
            <CartItem
              key={orderProduct.id}
              orderProduct={orderProduct}
              currency={currency}
              onAddItem={handleUpdateQuantity}
              onDeductItem={handleUpdateQuantity}
            />
          ))
        ) : (
          <div>Nothing has been added to your cart yet!</div>
        )}
      </div>
      {orderProducts.length > 0 && (
        <RecommendedItems
          orderId={orderId}
          cartItems={orderProducts}
          storeCurrency={storeCurrency}
          handleSetModalItem={onEdit}
        />
      )}
    </div>
  );
};

export default Cart;
